import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import paths from './paths';
import store from '@/store/index';
import { IRootState, IAppState } from '@/models/State';
import { Module } from 'vuex';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: paths,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {

  if (store.state.AppStore.state !== undefined) {
    const appState: any = store.state.AppStore;
    if (appState.profile.isLocked && to.path !== '/lock') {
      next('/lock');
    }
  } else {
    NProgress.start();
    next();
  }
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
